import React, { PureComponent } from 'react';

import { get } from 'lodash-es';

import Button from '@atlaskit/button';
import DropdownMenu, {
  DropdownItemGroup,
  DropdownItem,
} from '@atlaskit/dropdown-menu-12';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import PresenceActiveIcon from '@atlaskit/icon/glyph/presence-active';
import { ConnectModules } from '@atlassian/bitbucket-connect-react';

import { commitFileTarget, CommitFileTargetProps } from 'src/connect/targets';

import { DEFAULT_EDITOR_KEY } from './file-editor';
import * as styles from './file-module-menu.style';

export type FileModuleMenuProps = CommitFileTargetProps & {
  defaultLabel: string;
  moduleKey?: string;
  moduleType: 'fileViews' | 'fileEditors';
  onSelect: (moduleKey?: string) => void;
  principalId: string;
};

export class FileModuleMenu extends PureComponent<FileModuleMenuProps> {
  render() {
    const {
      defaultLabel,
      hash,
      moduleKey,
      moduleType,
      path,
      principalId,
      repositoryOwner,
      repositorySlug,
    } = this.props;

    return (
      <ConnectModules
        principalId={principalId}
        target={commitFileTarget({
          path,
          hash,
          repositoryOwner,
          repositorySlug,
        })}
        moduleType={moduleType}
      >
        {({ modules }) => {
          if (!modules.length) {
            return false;
          }

          const selected = modules.find(
            mod => mod.descriptor.key === moduleKey
          );

          return (
            <styles.DropdownWrapper>
              <DropdownMenu
                placement="bottom-end"
                trigger={({ triggerRef, ...props }) => (
                  <Button
                    {...props}
                    iconAfter={<ChevronDownIcon label="" />}
                    appearance="subtle"
                    ref={triggerRef}
                  >
                    {selected
                      ? get(selected, 'descriptor.name.value')
                      : defaultLabel}
                  </Button>
                )}
                shouldFitContainer
              >
                <DropdownItemGroup>
                  <DropdownItem
                    onClick={() => this.props.onSelect(DEFAULT_EDITOR_KEY)}
                  >
                    <styles.MenuItem>
                      <styles.IconWrapper>
                        {!selected && (
                          <PresenceActiveIcon size="small" label="" />
                        )}
                      </styles.IconWrapper>
                      <span>{defaultLabel}</span>
                    </styles.MenuItem>
                  </DropdownItem>
                  {modules.map(mod => (
                    <DropdownItem
                      key={mod.id}
                      onClick={() => this.props.onSelect(mod.descriptor.key)}
                    >
                      <styles.MenuItem>
                        <styles.IconWrapper>
                          {moduleKey === mod.descriptor.key && (
                            <PresenceActiveIcon size="small" label="" />
                          )}
                        </styles.IconWrapper>
                        <span>{get(mod, 'descriptor.name.value')}</span>
                      </styles.MenuItem>
                    </DropdownItem>
                  ))}
                </DropdownItemGroup>
              </DropdownMenu>
            </styles.DropdownWrapper>
          );
        }}
      </ConnectModules>
    );
  }
}
